<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import Cookies from "js-cookie";
import qs from "qs";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import { TestInternet } from "@/js/network.js";
import { directorApi } from "./api/api-director";
import { EventBus } from "./utils/eventBus";
moment.locale("zh-cn");
export default {
  name: "App",
  data() {
    return {
      zh_CN,
    };
  },
  methods: {
    loadCssCode(code) {
      var style = document.createElement("style");
      style.type = "text/css";
      style.rel = "stylesheet";
      try {
        //for Chrome Firefox Opera Safari
        style.appendChild(document.createTextNode(code));
      } catch (ex) {
        //for IE
        style.styleSheet.cssText = code;
      }
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(style);
    },
    getFonts() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.getFonts,
        headers: { Authorization: this.$store.state.headers },
        data: { limit: 100, page: 1, uid: 18 },
      })
        .then((res) => {
          // this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.fontlist = res.data.data.data;
            var fonts = [];
            this.fontlist.forEach((arr) => {
              fonts.push(arr.name);
            });
            this.$store.dispatch("setFonts", fonts);
            console.log(fonts);
            var css = "";
            this.fontlist.forEach((element, index) => {
              if (index <= 15) {
                css += "@font-face{";
                css += "font-style: normal;";
                css += "font-weight: regular;";
                css += `font-family: '${element.name}';`;
                css += `src:url("${element.file}");}`;
                css += `.ql-font-${element.name} {`;
                css += `font-family: '${element.name}';}`;
                css += `.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${element.name}"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${element.name}"]::before {`;
                css += `content: "${element.name}";`;
                css += `font-family: "${element.name}";}`;
              }
            });
            this.loadCssCode(css);
            var css2 = "";
            this.fontlist.forEach((element, index) => {
              if (index > 15 && index <= 30) {
                css2 += "@font-face{";
                css2 += "font-style: normal;";
                css2 += "font-weight: regular;";
                css2 += `font-family: '${element.name}';`;
                css2 += `src:url("${element.file}");}`;
                css2 += `.ql-font-${element.name} {`;
                css2 += `font-family: '${element.name}';}`;
                css2 += `.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${element.name}"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${element.name}"]::before {`;
                css2 += `content: "${element.name}";`;
                css2 += `font-family: "${element.name}";}`;
              }
            });
            this.loadCssCode(css2);
            css2 = "";
            this.fontlist.forEach((element, index) => {
              if (index > 30 && index <= 50) {
                css2 += "@font-face{";
                css2 += "font-style: normal;";
                css2 += "font-weight: regular;";
                css2 += `font-family: '${element.name}';`;
                css2 += `src:url("${element.file}");}`;
                css2 += `.ql-font-${element.name} {`;
                css2 += `font-family: '${element.name}';}`;
                css2 += `.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${element.name}"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${element.name}"]::before {`;
                css2 += `content: "${element.name}";`;
                css2 += `font-family: "${element.name}";}`;
              }
            });
            this.loadCssCode(css2);
            css2 = "";
            this.fontlist.forEach((element, index) => {
              if (index > 50) {
                css2 += "@font-face{";
                css2 += "font-style: normal;";
                css2 += "font-weight: regular;";
                css2 += `font-family: '${element.name}';`;
                css2 += `src:url("${element.file}");}`;
                css2 += `.ql-font-${element.name} {`;
                css2 += `font-family: '${element.name}';}`;
                css2 += `.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="${element.name}"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="${element.name}"]::before {`;
                css2 += `content: "${element.name}";`;
                css2 += `font-family: "${element.name}";}`;
              }
            });
            this.loadCssCode(css2);
          }
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("网络或服务器未知错误");
        });
    },
    login() {
      var form = Cookies.get("loginform");
      if (form && form != "undefined") {
        form = JSON.parse(form);
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.login,
          data: qs.stringify(form),
        })
          .then((res) => {
            this.$store.dispatch("setUserInfo", res.data.data);
            this.$store.dispatch("setHeader", res.data.token);
            if (!res.data.data.is_teacher || res.data.data.is_teacher == "0") {
              this.$message.error("您不是教师");
              setTimeout(() => {
                if (this.$route.path != "/login") {
                  this.$router.push({ path: "/login" });
                }
              }, 200);
              return false;
            }
            if (res.data.status == 200) {
              this.$axios({
                method: "POST",
                url: this.$api.domain + this.$api.teacherInfo,
                headers: {
                  Authorization: res.data.token,
                },
                data: qs.stringify(form),
              })
                .then((teahcherInfo) => {
                  if (teahcherInfo.data.status == 200) {
                    Cookies.set("loginform", form, { expires: 7 });
                    this.$message.success("登录成功！");
                    this.getFonts();
                    if (this.$route.path == "/login") {
                      setTimeout(() => {
                        this.$router.push({ path: "/createStudent" });
                      }, 800);
                    }
                  } else {
                    this.$router.push({ path: "/login" });
                  }
                })
                .catch(() => {
                  this.$router.push({ path: "/login" });
                });
            } else {
              this.$router.push({ path: "/login" });
            }
          })
          .catch(() => {
            this.$router.push({ path: "/login" });
          });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    uniLogin(id) {
      this.$message.loading("登录中...", 1.2);
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.uidLogin,
        data: {
          union_id: id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.$store.dispatch("setUserInfo", res.data.data);
            this.$store.dispatch("setHeader", res.data.token);
            this.getFonts();
            if (!res.data.data.is_teacher || res.data.data.is_teacher == "0") {
              this.$message.error("您不是教师");
              setTimeout(() => {
                if (this.$route.path != "/login") {
                  this.$router.push({ path: "/login" });
                }
              }, 200);
              return false;
            }
            this.$message.success("登录成功！");
            localStorage.setItem("uid", id);
            console.log(this.$route);
            if (this.$route.path == "/login") {
              setTimeout(() => {
                this.$router.push({ path: "/createStudent" });
              }, 800);
            }
          } else {
            localStorage.setItem("uid", "");
            setTimeout(() => {
              this.$message.error("微信身份登录失败");
            }, 1000);
            if (this.$route.path != "/login") {
              this.$router.push({ path: "/login" });
            }
          }
        })
        .catch((e) => {
          console.log(e);
          localStorage.setItem("uid", "");
          if (this.$route.path != "/login") {
            this.$router.push({ path: "/login" });
          }
        });
    },
    urladd(name) {
      var url = location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
    tokenLogin(token) {
      this.$axios({
        method: "GET",
        url: directorApi.domain + directorApi.userInfo,
        headers: {
          Authorization: token,
        },
      })
        .then((teahcherInfo) => {
          if (teahcherInfo.data.status == 200) {
            this.$store.dispatch("setUserInfo", teahcherInfo.data.data);
            this.$store.dispatch("setHeader", token);
            const locId = localStorage.getItem("directorId");
            const school = localStorage.getItem("school");
            if (locId == teahcherInfo.data.data.id && school) {
              this.$store.dispatch("setSchool", JSON.parse(school));
            } else {
              this.$store.dispatch(
                "setSchool",
                teahcherInfo.data.data.schools[0],
              );
              localStorage.setItem("directorId", teahcherInfo.data.data.id);
              localStorage.setItem(
                "school",
                JSON.stringify(teahcherInfo.data.data.schools[0]),
              );
            }

            this.getFonts();

            if (window.location.href.indexOf("/director/login") > -1) {
              setTimeout(() => {
                this.$router.push({ path: "/director/index" });
              }, 800);
            }
          } else {
            Cookies.remove("token");
          }
        })
        .catch((e) => {
          console.log(e);
          Cookies.remove("token");
          this.$router.push({ path: "/director/login" });
        });
    },
    getToken(signKey) {
      this.$axios({
        method: "get",
        url: directorApi.main + "/schools/Login/getAuth",
        params: {
          signKey: signKey,
        },
      }).then((res) => {
        if (res.data.data) {
          this.$store.state.headers = res.data.data.token;
          this.tokenLogin(res.data.data.token);
        } else {
          //弹窗提示权限
          this.$message.error("权限不足");
        }
      });
    },
    getTeacherToken(signKey) {
      this.$axios({
        method: "get",
        url: this.$api.domain + "/schools/Login/getAuth",
        params: {
          signKey: signKey,
        },
      }).then((res) => {
        if (res.data.data) {
          this.$store.state.headers = res.data.data.token;
          this.$store.dispatch("setHeader", token);
          this.$axios({
            method: "GET",
            url: this.$api.domain + this.$api.getUserInfo,
            headers: {
              Authorization: token,
            },
          })
            .then((teahcherInfo) => {
              if (teahcherInfo.data.status == 200) {
                this.$store.dispatch("setUserInfo", teahcherInfo.data.data);
                this.getFonts();
                if (!teahcherInfo.data.data) {
                  this.$router.push({ path: "/login" });
                  return;
                }
                if (this.$route.path == "/login") {
                  setTimeout(() => {
                    this.$router.push({ path: "/createStudent" });
                  }, 800);
                }
              } else {
                // this.$router.push({ path: "/login" });
                Cookies.remove("token");
              }
            })
            .catch(() => {
              Cookies.remove("token");
              this.$router.push({ path: "/login" });
            });
        } else {
          //弹窗提示权限
          this.$message.error("权限不足");
        }
      });
    },
  },
  created() {
    EventBus.$on("getFonts", () => {
      this.getFonts();
    });
    TestInternet(this);
    window.onoffline = () => {
      this.$notification["error"]({
        message: "网络错误",
        description: "您的网络已断开，请重新连接。否则操作无法正常执行",
      });
      this.$store.dispatch("setOnline", false);
    };
    window.ononline = () => {
      this.$store.dispatch("setOnline", true);
    };
    var id = this.urladd("id");
    var uid = localStorage.getItem("uid");
    var token = this.urladd("token")
      ? this.urladd("token")
      : Cookies.get("token");
    if (token && window.location.href.indexOf("director") > -1) {
      this.$axios({
        method: "GET",
        url: directorApi.domain + directorApi.userInfo,
        headers: {
          Authorization: token,
        },
      })
        .then((teahcherInfo) => {
          if (teahcherInfo.data.status == 200) {
            this.$store.dispatch("setUserInfo", teahcherInfo.data.data);
            this.$store.dispatch("setHeader", token);
            const locId = localStorage.getItem("directorId");
            const school = localStorage.getItem("school");
            if (locId == teahcherInfo.data.data.id && school) {
              this.$store.dispatch("setSchool", JSON.parse(school));
            } else {
              this.$store.dispatch(
                "setSchool",
                teahcherInfo.data.data.schools[0],
              );
              localStorage.setItem("directorId", teahcherInfo.data.data.id);
              localStorage.setItem(
                "school",
                JSON.stringify(teahcherInfo.data.data.schools[0]),
              );
            }

            this.getFonts();

            if (window.location.href.indexOf("/director/login") > -1) {
              setTimeout(() => {
                this.$router.push({ path: "/director/index" });
              }, 800);
            }
          } else {
            Cookies.remove("token");
          }
        })
        .catch((e) => {
          console.log(e);
          Cookies.remove("token");
          this.$router.push({ path: "/director/login" });
        });
      return false;
    } else if (!token && window.location.href.indexOf("director") > -1) {
      const signKey = this.urladd("signKey");
      this.getToken(signKey);
    }

    const signKey = this.urladd("signKey");
    const type = this.urladd("type");
    if (
      window.location.href.indexOf("director") < 0 &&
      signKey &&
      type == "school"
    ) {
      this.getTeacherToken(signKey);
      return;
    }

    if (
      window.location.href.indexOf("director/login") > -1 ||
      window.location.href.indexOf("file?id=") > -1
    )
      return;
    if (token && token.length > 8) {
      this.$store.dispatch("setHeader", token);
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.getUserInfo,
        headers: {
          Authorization: token,
        },
      })
        .then((teahcherInfo) => {
          if (teahcherInfo.data.status == 200) {
            this.$store.dispatch("setUserInfo", teahcherInfo.data.data);
            this.getFonts();
            if (!teahcherInfo.data.data) {
              this.$router.push({ path: "/login" });
              return;
            }
            if (this.$route.path == "/login") {
              setTimeout(() => {
                this.$router.push({ path: "/createStudent" });
              }, 800);
            }
          } else {
            // this.$router.push({ path: "/login" });
            Cookies.remove("token");
          }
        })
        .catch(() => {
          Cookies.remove("token");
          this.$router.push({ path: "/login" });
        });
      return false;
    }
    if (id) {
      Cookies.remove("token");
      this.uniLogin(id);
    } else {
      if (uid) {
        Cookies.remove("token");
        this.uniLogin(uid);
      } else {
        this.login();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
ol,
ul {
  margin-top: 0;
  margin-bottom: 0 !important;
  padding-top: 0;
  font-size: 0;
  padding-bottom: 0 !important;
  li {
    font-size: 14px;
  }
}
</style>

<style lang="scss">
input[aria-hidden="true"] {
  display: none !important;
}
.content ul li {
  font-size: 16px;
  color: #6a6a6a;
  strong {
    color: #333;
  }
}
.blue {
  color: #67b0dc;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    flex-shrink: 0;
  }
}

#app {
  color: #000;
  width: 100%;
  height: 100%;
  background: #f1f8fd;
  //消除锯齿
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: #f1f8fd;
}

::-webkit-scrollbar-track-piece {
  background-color: #f1f8fd;
}

::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  background-color: #f1f8fd;
  background-clip: padding-box;
  min-height: 18px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

.rightContent {
  position: fixed;
  border-radius: 4px;
  background: #fff;
  width: 120px;
  padding: 10px 0;
  z-index: 10;
  box-shadow: 0 0 5px 2px rgba($color: #000000, $alpha: 0.08);

  .cell {
    width: 100%;
    line-height: 32px;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    text-align: center;

    &:hover {
      background: #67b0dc;
      color: #fff;
    }
  }
}

//编辑器
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
  content: "宋体";
  font-family: "SimSun" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
  content: "黑体";
  font-family: "SimHei";
}

.ql-snow
  .ql-picker.ql-font
  .ql-picker-label[data-value="Microsoft-YaHei"]::before,
.ql-snow
  .ql-picker.ql-font
  .ql-picker-item[data-value="Microsoft-YaHei"]::before {
  content: "微软雅黑";
  font-family: "Microsoft YaHei";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
  content: "楷体";
  font-family: "KaiTi" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
  content: "仿宋";
  font-family: "FangSong";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
  content: "Arial";
  font-family: "Arial";
}

.ql-snow
  .ql-picker.ql-font
  .ql-picker-label[data-value="Times-New-Roman"]::before,
.ql-snow
  .ql-picker.ql-font
  .ql-picker-item[data-value="Times-New-Roman"]::before {
  content: "Times New Roman";
  font-family: "Times New Roman";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
  content: "sans-serif";
  font-family: "sans-serif";
}

.ql-font-SimSun {
  font-family: "SimSun";
}

.ql-font-SimHei {
  font-family: "SimHei";
}

.ql-font-Microsoft-YaHei {
  font-family: "Microsoft YaHei";
}

.ql-font-KaiTi {
  font-family: "KaiTi";
}

.ql-font-FangSong {
  font-family: "FangSong";
}

.ql-font-Arial {
  font-family: "Arial";
}

.ql-font-Times-New-Roman {
  font-family: "Times New Roman";
}

.ql-font-sans-serif {
  font-family: "sans-serif";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="262px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="262px"]::before {
  content: "大特号";
  font-size: 12px;
}

.ql-size-262px {
  font-size: 262.5px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="225px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="225px"]::before {
  content: "特号";
  font-size: 12px;
}

.ql-size-225px {
  font-size: 225px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="175px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="175px"]::before {
  content: "初号";
  font-size: 12px;
}

.ql-size-175px {
  font-size: 58.667px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="150px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="150px"]::before {
  content: "小初号";
  font-size: 12px;
}

.ql-size-150px {
  font-size: 48px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="131px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="131px"]::before {
  content: "小一号";
  font-size: 12px;
}

.ql-size-131px {
  font-size: 32px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="116px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="116px"]::before {
  content: "一号";
  font-size: 12px;
}

.ql-size-116px {
  font-size: 34.667px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="87px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="87px"]::before {
  content: "二号";
  font-size: 12px;
}

.ql-size-87px {
  font-size: 29.333px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="66px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="66px"]::before {
  content: "三号";
  font-size: 12px;
}

.ql-size-66px {
  font-size: 21.333px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="75px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="75px"]::before {
  content: "小二号";
  font-size: 12px;
}

.ql-size-75px {
  font-size: 24px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="58px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="58px"]::before {
  content: "四号";
  font-size: 12px;
}

.ql-size-58px {
  font-size: 18.667px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="50px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="50px"]::before {
  content: "小四号";
  font-size: 12px;
}

.ql-size-50px {
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="37px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="37px"]::before {
  content: "小五号";
  font-size: 12px;
}

.ql-size-37px {
  font-size: 12px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="33px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="33px"]::before {
  content: "六号";
  font-size: 10px;
}

.ql-size-33px {
  font-size: 10px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "小六号";
  font-size: 12px;
}

.ql-size-28px {
  font-size: 8.667px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "七号";
  font-size: 12px;
}

.ql-size-22px {
  font-size: 7.333px;
}

.ql-snow .ql-picker.ql-font {
  width: 128px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "八号";
  font-size: 12px;
}

.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 1em !important;
}

.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 2em !important;
}

.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 3em !important;
}

.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 4em !important;
}

.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 5em !important;
}

.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 6em !important;
}

.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 7em !important;
}

.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 0 !important;
  text-indent: 8em !important;
}

.ql-size-18px {
  font-size: 6.667px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="44px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="44px"]::before {
  content: "五号";
  font-size: 12px;
}

.ql-size-44px {
  font-size: 14px;
}

.ql-container .ql-editor {
  white-space: pre-wrap !important;
}

.head-title {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #bfc0c4;
  margin-top: 20px;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  height: 36px;
  flex-shrink: 0;

  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #898989;

    .main {
      font-size: 16px;
    }
  }

  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .num {
      font-size: 14px;
      color: #656464;

      span {
        margin: 0 4px;
      }

      border-right: 1px solid #ddd;
      margin-right: 15px;
      padding-right: 15px;
      box-sizing: border-box;
    }
  }
}

.modal3 {
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 100px;
    height: 100px;
  }

  .msg {
    flex: 1 1 0%;
    margin-left: 12px;
  }

  .btns {
    text-align: right;
    margin-top: 15px;

    .ant-btn {
      margin-left: 10px;
    }
  }

  .title {
    color: #67b0dc;
    margin-bottom: 5px;
    font-size: 16px;
  }
}

.modal.red {
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 100px;
    height: 100px;
  }

  .msg {
    flex: 1 1 0%;
    margin-left: 12px;
  }

  .btns {
    text-align: right;
    margin-top: 15 px;

    .ant-btn {
      margin-left: 10px;
    }
  }

  .title {
    color: #eb5c4b;
    margin-bottom: 5px;
    font-size: 16px;
  }
}

.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;

  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}

.head-title .left .name {
  font-size: 12px;
  cursor: pointer;
}

.head-title .left .icon {
  margin: 0 6px;
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "zkklt";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-15/95a5d790b7be24f0c43d9c9dfd8989fe.ttf");
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "zkgdht";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-15/2444f729af9544953b9d8afcab34845b.ttf");
}

.ql-font-zkklt {
  font-family: "zkklt";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="zkklt"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="zkklt"]::before {
  content: "站酷快乐体";
  font-family: "zkklt";
}

.ql-font-zkgdht {
  font-family: "zkgdht";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="zkgdht"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="zkgdht"]::before {
  content: "站酷高端黑体";
  font-family: "zkgdht";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "xygpbt";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/7655a7f64f9d735beb5d091306833b09.ttf");
}

.ql-font-zkklt {
  font-family: "xygpbt";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="xygpbt"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="xygpbt"]::before {
  content: "新愚公拼搏体";
  font-family: "xygpbt";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "xwmh";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/0ca7c5c01f824e8f3793938dee0874b1.ttf");
}

.ql-font-zkklt {
  font-family: "xwmh";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="xwmh"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="xwmh"]::before {
  content: "霞鹜漫黑";
  font-family: "xwmh";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "bbt";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/f7182b037e4528b58934b6fcb952003d.ttf");
}

.ql-font-zkklt {
  font-family: "bbt";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="bbt"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="bbt"]::before {
  content: "泡泡体";
  font-family: "bbt";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "dyt";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/908b9b08c9ab6f58c55c6619b61f9378.otf");
}

.ql-font-zkklt {
  font-family: "dyt";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="dyt"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="dyt"]::before {
  content: "斗鱼体";
  font-family: "dyt";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "fzfs";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/49cef715094a96618d04f7489c5722ca.ttf");
}

.ql-font-zkklt {
  font-family: "fzfs";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="fzfs"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="fzfs"]::before {
  content: "方正仿宋";
  font-family: "fzfs";
}

@font-face {
  font-style: normal;
  font-weight: regular;
  font-family: "fzkt";
  src: url("https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-16/3abb53c306de67dd41153101f07ef75f.ttf");
}

.ql-font-zkklt {
  font-family: "fzkt";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="fzkt"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="fzkt"]::before {
  content: "方正仿宋";
  font-family: "fzkt";
}

.ql-align-right {
  text-align: right !important;
}

.ql-align-center {
  text-align: center !important;
}

.ql-picker-options {
  height: 300px;
  overflow-y: scroll;
}

div,
p {
  letter-spacing: 0em !important;
}

.ant-upload-list-picture-card-container .ant-upload-list-item-undefined {
  border: 2px solid #c02b1b !important;
}
.build-item {
  position: relative;
}
.build-item::after {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  content: "";
}

.textflow2 {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.3;
}

.card {
  background: #fff;
  border-radius: 10px;
}

body .ant-btn-primary {
  background-color: #67b0dc;
  border-color: #67b0dc;
}
</style>
